import type { FC } from 'react';
import {
  ScenarioSection,
  AuditNoticeSection,
  BobsDilemmaSection,
  DecisionDetailSection,
  TrustVerificationSection,
  AuditCompleteSection,
} from '@/sections';
import { HorizontalPager } from '@/components/layout/HorizontalPager';

/**
 * Example Page — 完整审计示例流程
 * 6 步可视化：场景 → 通知 → 困境 → 决策详情 → 验证 → 完成
 */
const Example: FC = () => {
  return (
    <main>
      <HorizontalPager>
        <ScenarioSection />
        <AuditNoticeSection />
        <BobsDilemmaSection />
        <DecisionDetailSection />
        <TrustVerificationSection />
        <AuditCompleteSection />
      </HorizontalPager>
    </main>
  );
};

export default Example;
